/*
    🔥 HEADER PUBLIC
        Adaptador del HeaderShell para las vistas públicas.
        Recibe marca, navegación y utilidades ya resueltas por AppLayoutPublic.

        El template visual utilizado proviene de APP_SWITCH_APPEARANCE, cuya
        fuente final es APP_CONFIG_GLOBAL.TEMPLATES.HEADER_PUBLIC_APPEARANCE.
*/

import { HeaderShell } from './_Parts/HeaderShell';
import { APP_SWITCH_APPEARANCE } from '../../../../_CORE/_RuntimeConfig/_Config/Acomodar/AppSwitchAppearance.js';

export const AppHeaderPublic = ({ brand = null, navItems = [], utilities = null, templateId = null }) => (
    <HeaderShell
        templateId={templateId ?? APP_SWITCH_APPEARANCE.STYLES.HEADER_TOP_PUBLIC}
        brand={brand}
        navItems={navItems}
        utilities={utilities}
        homePath="/"
    />
);
